/* eslint-disable import/prefer-default-export */
import { makeProxyRequest } from '../utils/request';
import { generic } from './helper';

export const getWLCompanyDataAPI = () =>
  makeProxyRequest('get', generic('/whitelabelconfig'));
